import { http } from "api/http";

const saveAuthToken = ({ queryKey }) => {
  return http.post("/onedrive/save-token", { ...queryKey[1] });
};

const getOneDriveItems = ({ queryKey }) => {
  return http.get("/onedrive", { params: { ...queryKey[1] } });
};

const reAuthorize = () => {
  return http.post("/onedrive/re-authorize");
};

const googleDrivereAuthorize = () => {

  return http.post("/googledrive/re-authorize");

};

const getGoogleDriveItems = ({ queryKey }) => {
  return http.get("/googledrive", { params: { ...queryKey[1] } });
};
const getGmailItems = ({ queryKey }) => {
  return http.get("/googledrive/gmail", { params: { ...queryKey[1] } });
};

const getGmailItemDetails = ({ queryKey }) => {
  console.log(queryKey[1])
  const { id } = queryKey[1]
  return http.get(`/googledrive/gmail/${id}`)
}

const sendGmail = (queryKey) => {
  const { id, body } = queryKey;
  console.log({ id, body });
  return http.post(`/googledrive/send-gmail/${id}`, { body })
}

const composeMail = (queryKey) => {
  console.log(queryKey)
  return http.post(`/googledrive/compose-mail`, queryKey)
}

const saveGoogleAuthToken = ({ queryKey }) => {
  return http.post("/googledrive/save-token", { ...queryKey[1] });
};

const removeOneDriveFile = (id: string) => {
  return http.delete(`/onedrive/remove-file/${id}`);
};

const enableAutomationBulkSync = () => {
  return http.put("/automation/enable-bulk-sync");
};

export {
  getOneDriveItems,
  saveAuthToken,
  reAuthorize,
  googleDrivereAuthorize,
  getGoogleDriveItems,
  saveGoogleAuthToken,
  removeOneDriveFile,
  getGmailItemDetails,
  sendGmail,
  getGmailItems,
  composeMail,
  enableAutomationBulkSync,
};
